import { ArrowRight } from 'lucide-react';

const accents = {
  amber: { bar: 'border-amber-500', label: { dark: 'text-amber-400', light: 'text-amber-700' }, spine: { dark: 'bg-amber-500/40', light: 'bg-amber-300' } },
  cyan: { bar: 'border-cyan-500', label: { dark: 'text-cyan-400', light: 'text-cyan-700' }, spine: { dark: 'bg-cyan-500/40', light: 'bg-cyan-300' } },
  indigo: { bar: 'border-indigo-500', label: { dark: 'text-indigo-400', light: 'text-indigo-700' }, spine: { dark: 'bg-indigo-500/40', light: 'bg-indigo-300' } },
  neutral: { bar: 'border-slate-400', label: { dark: 'text-slate-400', light: 'text-slate-600' }, spine: { dark: 'bg-slate-500/40', light: 'bg-slate-300' } },
};

const ExecutiveFlowRail = ({ phases, theme, variant = 'neutral' }) => {
  const isDark = theme === 'dark';
  const mode = isDark ? 'dark' : 'light';
  const accent = accents[variant] || accents.neutral;

  return (
    <>
      <div className="hidden lg:block">
        <div className="flex items-stretch">
          {phases.map((phase, index) => (
            <div key={phase.title} className="flex items-stretch flex-1 min-w-0">
              <div className={`flex-1 border-t-2 ${accent.bar} p-8 ${isDark ? 'bg-slate-950/50' : 'bg-white'}`}>
                <span className={`text-[11px] font-semibold uppercase tracking-[0.22em] ${accent.label[mode]}`}>
                  Phase {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className={`text-xl font-semibold mt-3 mb-3 ${isDark ? 'text-white' : 'text-slate-900'}`}>
                  {phase.title}
                </h3>
                <p className={`text-base leading-relaxed ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
                  {phase.description}
                </p>
              </div>
              {index < phases.length - 1 && (
                <div className={`flex items-center px-3 ${accent.label[mode]}`}>
                  <ArrowRight className="w-5 h-5 opacity-60" aria-hidden />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="lg:hidden space-y-0">
        {phases.map((phase, index) => (
          <div key={phase.title} className="flex gap-5">
            <div className="flex flex-col items-center">
              <div className={`w-3 h-3 rounded-full ${accent.spine[mode]}`} />
              {index < phases.length - 1 && <div className={`w-px flex-1 min-h-[2rem] my-1 ${accent.spine[mode]}`} />}
            </div>
            <div className={`pb-8 ${index === phases.length - 1 ? 'pb-0' : ''}`}>
              <span className={`text-[11px] font-semibold uppercase tracking-[0.22em] ${accent.label[mode]}`}>
                {phase.title}
              </span>
              <p className={`mt-2 text-base leading-relaxed ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
                {phase.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ExecutiveFlowRail;
